import { Component, OnInit, AfterViewInit } from "@angular/core";
import { NgOnChangesFeature } from "@angular/core/src/render3";
import { Event } from "@angular/router";
// import { SharedService } from '../../services/shared/shared.service';
import { CommonService } from "../../services/common/common.service";
import { COMMONTEXT } from "../../app.constants";
import { SharedService } from "src/app/services/shared/shared.service";

@Component({
  selector: "app-side-bar",
  templateUrl: "./side-bar.component.html",
  styleUrls: ["./side-bar.component.css"],
})
export class SideBarComponent implements AfterViewInit, OnInit {
  showHoMenu: boolean = false;
  userRole = {
    applicationApproval: {
      status: false,
      name: "",
    },

    individualApproval: {
      status: false,
      name: "",
    },
    adminSupport: {
      status: false,
      name: "",
    },

    addMasterBank: {
      status: false,
      name: "",
    },

    editMasterBank: {
      status: false,
      name: "",
    },
    addBankBranch: {
      status: false,
      name: "",
    },
    editBankBranch: {
      status: false,
      name: "",
    },
    editApplication: {
      status: false,
      name: "",
    },
    changeOdop: {
      status: false,
      name: "",
    },
    searchIfsc: {
      status: false,
      name: "",
    },
    internalDashboard: {
      status: false,
      name: "",
    },
    drpDlcList: {
      status: false,
      name: "",
    },
    uploadBatchFileNpmu: {
      status: false,
      name: "",
    },
    viewResponseFiles: {
      status: false,
      name: "",
    },
    subsidyPaymentReport: {
      status: false,
      name: "",
    },
    subsidyProcessRequest: {
      status: false,
      name: "",
    },
    uploadResponseFiles: {
      status: false,
      name: "",
    },
    prayasDashboard: {
      status: false,
      name: "",
    },
    nrlmDashboard: {
      status: false,
      name: "",
    },
    manageMenu: {
      status: false,
      name: "",
    },
    mergeBranch: {
      status: false,
      name: "",
    },
    changeTransient: {
      status: false,
      name: "",
    },
    dfs: {
      status: false,
      name: ''
    },
    bankSanction: {
      status: false,
      name: ''
    },
    stateDfs: {
      status: false,
      name: ''
    },
    gatiShakti: {
      status: false,
      name: ''
    },
    parkedReport: {
      status: false,
      name: ''
    },
    additionalDocumentReport: {
      status: false,
      name: ''
    },
    bankPendingReport: {
      status: false,
      name: ''
    },
    bankSanctionReport: {
      status: false,
      name: ''
    },
    bankStatusApplicationReport: {
      status: false,
      name: ''
    },
    verifyLocation: {
      status: false,
      name: ''
    },
    hoReport: {
      status: false,
      name: ''
    },
    updateLocation: {
      status: false,
      name: "",
    },
    hoVerification: {
      status: false,
      name: "",
    },
    externalServicesAPIs: {
      status: false,
      name: "",
    },
    manageServiceTokens: {
      status: false,
      name: "",
    },
    addServiceTokens: {
      status: false,
      name: "",
    },
    buildAndReleases: {
      status: false,
      name: "",
    },
    snaContactDetails: {
      status: false,
      name: "",
    },
    adminReport: {
      status: false,
      name: "",
    },
    aLlReleases: {
      status: false,
      name: "",
    },
    addNewBuild: {
      status: false,
      name: "",
    },
    mediaUpload: {
      status: false,
      name: "",
    },
    uploadMedia: {
      status: false,
      name: "",
    },

    publishMedia: {
      status: false,
      name: "",
    },

    whosWho: {
      status: false,
      name: "",
    },
    addWhosWho: {
      status: false,
      name: "",
    },
    publishWhosWho: {
      status: false,
      name: "",
    },
    listWhosWho: {
      status: false,
      name: "",
    },
    subsidyRelease: {
      status: false,
      name: "",
    },
    createBatch: {
      status: false,
      name: "",
    },
    subsidyProcess: {
      status: false,
      name: "",
    },
    viewSubsidy: {
      status: false,
      name: "",
    },
    grantRelease: {
      status: false,
      name: "",
    },
    subsidyReportData: {
      status: false,
      name: "",
    },
    editSubsidy: {
      status: false,
      name: "",
    },

    drpManagement: {
      status: false,
      name: "",
    },
    addDrp: {
      status: false,
      name: "",
    },
    approveDrp: {
      status: false,
      name: "",
    },
    extendUserValidity: {
      status: false,
      name: "",
    },
    smsDashboard: {
      status: false,
      name: "",
    },
    shiftApplication: {
      status: false,
      name: "",
    },
    subsidyReport: {
      status: false,
      name: "",
    },
    stateStb: {
      status: false,
      name: "",
    },
    bankwiseSenttobank: {
      status: false,
      name: "",
    },
    withrawnApplication: {
      status: false,
      name: "",
    },
    statewiseSanctioned: {
      status: false,
      name: "",
    },
    statewisePending: {
      status: false,
      name: "",
    },
    bankwiseSanctioned: {
      status: false,
      name: "",
    },
    bankwisePending: {
      status: false,
      name: "",
    },
    bankwiseRejected: {
      status: false,
      name: "",
    },
    stateWiseRejected: {
      status: false,
      name: "",
    },
    zonalVerification: {
      status: false,
      name: "",
    },
    multipleDrp: {
      status: false,
      name: "",
    },



    // defficiencyLetterState:{
    //   status: false,
    //   name:''
    // },

    nonIndividualApproval: {
      status: false,
      name: "",
    },

    bankLinkageMOFPI: {
      status: false,
      name: "",
    },

    bankLinkageHoMOFPI: {
      status: false,
      name: "",
    },

    bankLinkageMOFPIInner: {
      status: false,
      name: "",
    },
    dPRPendingApproval: {
      status: false,
      name: "",
    },

    individualHoApproval: {
      status: false,
      name: "",
    },
    editProfile: {
      status: false,
      name: "",
    },
    loanReleaseDetails: {
      status: false,
      name: "",
    },
    loanDisbursementHo: {
      status: false,
      name: "",
    },
    rollbackDisbursement: {
      status: false,
      name: "",
    },
    rollbackDisbursementHo: {
      status: false,
      name: "",
    },
    editSanctionsDetails: {
      status: false,
      name: "",
    },

    editSanctionsNotAble: {
      status: false,
      name: "",
    },
    nodalBankStatus: {
      status: false,
      name: "",
    },
    nonIndividual: {
      status: false,
      name: "",
    },
    groupHoApproval: {
      status: false,
      name: "",
    },
    contentManagement: {
      status: false,
      name: "",
    },
    subsidyStatusUpdate: {
      status: false,
      name: "",
    },
    convergenceModule: {
      status: false,
      name: "",
    },
    dashboardsDataAnalytics: {
      status: false,
      name: "",
    },
    bankReport: {
      status: false,
      name: "",
    },
    fundMonitoring: {
      status: false,
      name: "",
    },

    rollBackDecision: {
      status: false,
      name: "",
    },

    

    sanctionedApplications: {
      status: false,
      name: "",
    },
    sanctionedApplicationsHo: {
      status: false,
      name: "",
    },
    grievance: {
      status: false,
      name: "",
    },
    formalisation: {
      status: false,
      name: "",
    },
    grievanceRedressal: {
      status: false,
      name: "",
    },
    home: {
      status: false,
      name: "",
    },
    mobileInterfaces: {
      status: false,
      name: "",
    },

    // applicationApproval: {
    //   status: false,
    //   name: ''
    // },
    // individualApproval: {
    //   status: false,
    //   name: ''
    // },
    // nonIndividualApproval: {
    //   status: false,
    //   name: ''
    // },
    performanceMonitoring: {
      status: false,
      name: "",
    },
    monitoringReport: {
      status: false,
      name: "",
    },

    incubationCentre: {
      status: false,
      name: "",
    },
    reports: {
      status: false,
      name: "",
    },
    lendingBankReport: {
      status: false,
      name: "",
    },
    lendingBankReportV2: {
      status: false,
      name: "",
    },
    viewReports: {
      status: false,
      name: "",
    },
    proposedPdtReport: {
      status: false,
      name: "",
    },
    proposedBusinessReport: {
      status: false,
      name: "",
    },
    appFinInfoReport: {
      status: false,
      name: "",
    },
    defLetterDlc: {
      status: false,
      name: "",
    },
    stateWiseApplicantProfile: {
      status: false,
      name: "",
    },
    mostPrefBnkAprvdApp: {
      status: false,
      name: "",
    },
    subAmtNtSubmitedState: {
      status: false,
      name: "",
    },
    loanRejBothPrefBank: {
      status: false,
      name: "",
    },
    loanAmtApprvSecondBank: {
      status: false,
      name: "",
    },
    beneficiaryLoanTracking: {
      status: false,
      name: "",
    },
    dprPerformanceReport: {
      status: false,
      name: "",
    },
    grevResolvedIssues: {
      status: false,
      name: "",
    },
    schemeFundAccounting: {
      status: false,
      name: "",
    },
    schemeSitesSubSites: {
      status: false,
      name: "",
    },
    viewSiteSubsite: {
      status: false,
      name: "",
    },
    manageImageGallery: {
      status: false,
      name: "",
    },
    manageBannerImages: {
      status: false,
      name: "",
    },
    manageLatestUpdate: {
      status: false,
      name: "",
    },
    lmsMainMenu: {
      status: false,
      name: "",
    },
    manageSlupStudies: {
      status: false,
      name: "",
    },
    manageContactDetails: {
      status: false,
      name: "",
    },
    manageWhatsNew: {
      status: false,
      name: "",
    },
    manageImportantLinks: {
      status: false,
      name: "",
    },
    manageMediaLinks: {
      status: false,
      name: "",
    },
    manageOdop: {
      status: false,
      name: "",
    },
    uploadSampleProduct: {
      status: false,
      name: "",
    },
    successStories: {
      status: false,
      name: "",
    },
    manageWebsiteLinks: {
      status: false,
      name: "",
    },
    editSiteSubsite: {
      status: false,
      name: "",
    },
    userManagement: {
      status: false,
      name: "",
    },
    manageRole: {
      status: false,
      name: "",
    },
    activateUser: {
      status: false,
      name: "",
    },
    axisBankUser: {
      status: false,
      name: "",
    },
    searchCreatedUser: {
      status: false,
      name: "",
    },
    manageUser: {
      status: false,
      name: "",
    },
    resetPassword: {
      status: false,
      name: "",
    },

    hoBankUserMgmt: {
      status: false,
      name: "",
    },
    hoAddBank: {
      status: false,
      name: "",
    },
    hoEditBank: {
      status: false,
      name: "",
    },
    hoResetPassword: {
      status: false,
      name: "",
    },
    hoActivateId: {
      status: false,
      name: "",
    },

    grevNtResolvedNoAction: {
      status: false,
      name: "",
    },
    defficiencyLetterState: {
      status: false,
      name: "",
    },
    monitoringMainMenu: {
      status: false,
      name: "",
    },
    guidelinesInstructions: {
      status: false,
      name: "",
    },
    userManual: {
      status: false,
      name: "",
    },
    applicationView: {
      status: false,
      name: "",
    },
    statusUpdateMofpi: {
      status: false,
      name: "",
    },
    subsidyUpdate: {
      status: false,
      name: "",
    },
    totalSalesReport: {
      status: false,
      name: "",
    },
    totalCertificatesReport: {
      status: false,
      name: "",
    },
    loanDefaultersReport: {
      status: false,
      name: "",
    },
    totalInvestmentReport: {
      status: false,
      name: "",
    },
    loanEmiRepaymentReport: {
      status: false,
      name: "",
    },
    applicantsNumberLoanRepaymentReport: {
      status: false,
      name: "",
    },
    totalWorkersReport: {
      status: false,
      name: "",
    },
    projectMonitoring: {
      status: false,
      name: "",
    },
    bankApprovedAppRep: {
      status: false,
      name: "",
    },
    bankApprovedAppGraphRep: {
      status: false,
      name: "",
    },
    totalSubsidyDisRep: {
      status: false,
      name: "",
    },
    loginUserReport: {
      status: false,
      name: "",
    },
    formalisationReport: {
      status: false,
      name: "",
    },
    sanctionButNotDisbursed: {
      status: false,
      name: "",
    },
    downloadLendingBank: {
      status: false,
      name: "",
    },
    beneficiarLifeCycle: {
      status: false,
      name: "",
    },
    beneficiaryStatusReport: {
      status: false,
      name: "",
    },
    grievanceCountReport: {
      status: false,
      name: "",
    },
    loanOutstandingStatus: {
      status: false,
      name: "",
    },
    loanDefaulters: {
      status: false,
      name: "",
    },
    loanSanctionRejection: {
      status: false,
      name: "",
    },
    incubationCentreReport: {
      status: false,
      name: "",
    },
    incubationCentreReportDetails: {
      status: false,
      name: "",
    },
    certificationsStandardAchieved: {
      status: false,
      name: "",
    },
    beneficiaryBusinessLifecycle: {
      status: false,
      name: "",
    },
    beneficiaryBusinessLifecycleApplicantType: {
      status: false,
      name: "",
    },
    totalWorkerEmployedBeneficiary: {
      status: false,
      name: "",
    },
    loanSanctionRejectionOverallBeneficiary: {
      status: false,
      name: "",
    },
    loanSanctionRejectionOverallBanklevel: {
      status: false,
      name: "",
    },
    beneficiarySalesReport: {
      status: false,
      name: "",
    },
    downloadReportBank: {
      status: false,
      name: "",
    },
    downloadReportBankGroup: {
      status: false,
      name: "",
    },
    downloadReportDrpDlc: {
      status: false,
      name: "",
    },
    downloadReportIndividualStatus: {
      status: false,
      name: "",
    },
    downloadReportGroupStatus: {
      status: false,
      name: "",
    },
    downloadReportNonInd: {
      status: false,
      name: "",
    },
    downloadReportIndStatusV2: {
      status: false,
      name: "",
    },
    downloadReportNonIndStatusV2: {
      status: false,
      name: "",
    },
    pipMainMenu: {
      status: false,
      name: "",
    },
    statePipMenu: {
      status: false,
      name: "",
    },
    centralPipMenu: {
      status: false,
      name: "",
    },
    contentCreation: {
      status: false,
      name: "",
    },
    courseCreation: {
      status: false,
      name: "",
    },
    draftApplications: {
      status: false,
      name: "",
    },
    trainingCreation: {
      status: false,
      name: "",
    },
    directEnrollment: {
      status: false,
      name: "",
    },
    resultUpdate: {
      status: false,
      name: "",
    },
    updateTraining: {
      status: false,
      name: "",
    },
    trainingCommencement: {
      status: false,
      name: "",
    },
    viewTraining: {
      status: false,
      name: "",
    },
    snaSltiTraining: {
      status: false,
      name: "",
    },
    regMasterTrainer: {
      status: false,
      name: "",
    },
    trainerApproval: {
      status: false,
      name: "",
    },
    trainingMainMenu: {
      status: false,
      name: "",
    },
    cmsReport: {
      status: false,
      name: "",
    },
    detailedContentReport: {
      status: false,
      name: "",
    },
    contentExpenditure: {
      status: false,
      name: "",
    },
    internalSourceReg: {
      status: false,
      name: "",
    },
    internalSource: {
      status: false,
      name: "",
    },
    verifiedApplication: {
      status: false,
      name: "",
    },
    allVerifiedApplication: {
      status: false,
      name: "",
    },
    allPendingVerifiedApplication: {
      status: false,
      name: "",
    },
    zoneStateDistrict: {
      status: false,
      name: "",
    },
    zoneAdd: {
      status: false,
      name: "",
    },
    zoneView: {
      status: false,
      name: "",
    },
    internalSourceListDRP: {
      status: false,
      name: "",
    },
    allinternalSourceList: {
      status: false,
      name: "",
    },
    snaReportingStaff: {
      status: false,
      name: "",
    },
    snaReportingStaffIndivisual: {
      status: false,
      name: "",
    },
    snaReportingStaffNonIndivisual: {
      status: false,
      name: "",
    },
    AIFReport: {
      status: false,
      name: "",
    },
    downloadMonthlyApplicantDetail: {
      status: false,
      name: "",
    },
    downloadIndAndGroup: {
      status: false,
      name: "",
    },
    pullBackDocument: {
      status: false,
      name: "",
    },
  };
  userDetails;
  dispayApplication = false;
  displayBank = false;
  displayResetPassword = false;
  dispayReport = false;
  dispayBankReport = false;
  displayAllReport = false;
  hoRoleData: boolean;

  constructor(
    // private event: Event,

    private commonService: CommonService,
    private sharedService: SharedService
  ) { }

  ngOnInit() {
    this.getSideBarData();
    this.getUserDetails();
  }

  getSideBarData() { }

  getUserDetails() {
    this.sharedService.getLocalStorageItem("user").then((resp: any) => {
      // console.log('resp : ' + JSON.stringify(resp))
      if (resp) {
        this.userDetails = resp;
        if (
          this.userDetails.userType.userType == 1 ||
          this.userDetails.userType.userType == 2
        ) {
          this.dispayApplication = true;
        } else {
          this.dispayApplication = false;
        }

        if (
          this.userDetails.userType.userType == 1 ||
          this.userDetails.userType.userType == 2 ||
          this.userDetails.userType.userType == 3 ||
          this.userDetails.userType.userType == 4 ||
          this.userDetails.userType.userType == 5
        ) {
          this.dispayReport = true;
        } else {
          this.dispayReport = false;
        }

        if (
          this.userDetails.userType.userType == 5 ||
          this.userDetails.userType.userType == 6
        ) {
          this.dispayBankReport = true;
        } else {
          this.dispayBankReport = false;
        }

        if (
          this.userDetails.userType.userType == 1 ||
          this.userDetails.userType.userType == 2 ||
          this.userDetails.userType.userType == 3 ||
          this.userDetails.userType.userType == 4 ||
          this.userDetails.userType.userType == 5 ||
          this.userDetails.userType.userType == 6
        ) {
          this.displayAllReport = true;
        } else {
          this.displayAllReport = false;
        }

        if (this.userDetails.userType.userType == 7) {
          this.displayBank = true;
        } else {
          this.displayBank = false;
        }

        if (this.userDetails.userType.userType == 10) {
          this.displayResetPassword = true;
        } else {
          this.displayResetPassword = false;
        }
        // if(this.userDetails.userType.userType == 37){

        //  this.getSideBarData();
        console.log("this is show HO Menu in if condition", this.showHoMenu);
        //}
      }
    });
    this.prepareSideBar();
  }

  ngAfterViewInit() { }

  prepareSideBar() {
    // prepareSideBar() {
    // const userRole = this.sharedService.getUserRole()
    // console.log("userRole 2 : ", userRole)
    // this.setUserRole(userRole)
    this.sharedService.getLocalStorageItem("UserRole").then((role: any) => {
      // this.resetUserRole();
      // console.log("userRole 1 : ", role)
      // console.log('USER : ' + JSON.stringify(role))
      if (role != undefined && role != null) {
        // console.log("userRole 1 : ", role)

        this.setUserRole(role);
      } else {
        const userRole = this.sharedService.getUserRole();
        // console.log("userRole 2 : ", userRole)

        this.setUserRole(userRole);
      }
    });
  }

  setUserRole(allUserRole) {
    // console.log("allUserRole ", allUserRole);
    if (allUserRole) {
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 1 && mainMenu.isSelected == true) {
          this.userRole.home.status = true;
          this.userRole.home.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 2 && mainMenu.isSelected == true) {
          this.userRole.applicationApproval.status = true;
          this.userRole.applicationApproval.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 26 && subMenu.isSelected == true) {
              this.userRole.individualApproval.status = true;
              this.userRole.individualApproval.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 27 && subMenu.isSelected == true) {
              this.userRole.nonIndividualApproval.status = true;
              this.userRole.nonIndividualApproval.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 25 && mainMenu.isSelected === true) {
          this.userRole.adminSupport.status = true;
          this.userRole.adminSupport.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 102 && subMenu.isSelected == true) {
              this.userRole.addMasterBank.status = true;
              this.userRole.addMasterBank.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 103 && subMenu.isSelected == true) {
              this.userRole.editMasterBank.status = true;
              this.userRole.editMasterBank.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 105 && subMenu.isSelected == true) {
              this.userRole.editBankBranch.status = true;
              this.userRole.editBankBranch.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 104 && subMenu.isSelected == true) {
              this.userRole.addBankBranch.status = true;
              this.userRole.addBankBranch.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 106 && subMenu.isSelected == true) {
              this.userRole.editApplication.status = true;
              this.userRole.editApplication.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 121 && subMenu.isSelected == true) {
              this.userRole.changeOdop.status = true;
              this.userRole.changeOdop.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 26 && mainMenu.isSelected === true) {
          this.userRole.mediaUpload.status = true;
          this.userRole.mediaUpload.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 107 && subMenu.isSelected == true) {
              this.userRole.uploadMedia.status = true;
              this.userRole.uploadMedia.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 108 && subMenu.isSelected == true) {
              this.userRole.publishMedia.status = true;
              this.userRole.publishMedia.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 27 && mainMenu.isSelected === true) {
          this.userRole.whosWho.status = true;
          this.userRole.whosWho.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 109 && subMenu.isSelected == true) {
              this.userRole.addWhosWho.status = true;
              this.userRole.addWhosWho.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 110 && subMenu.isSelected == true) {
              this.userRole.publishWhosWho.status = true;
              this.userRole.publishWhosWho.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 111 && subMenu.isSelected == true) {
              this.userRole.listWhosWho.status = true;
              this.userRole.listWhosWho.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 50 && mainMenu.isSelected === true) {
          this.userRole.subsidyRelease.status = true;
          this.userRole.subsidyRelease.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 151 && subMenu.isSelected == true) {
              this.userRole.createBatch.status = true;
              this.userRole.createBatch.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 152 && subMenu.isSelected == true) {
              this.userRole.editSubsidy.status = true;
              this.userRole.editSubsidy.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 153 && subMenu.isSelected == true) {
              this.userRole.subsidyProcess.status = true;
              this.userRole.subsidyProcess.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 154 && subMenu.isSelected == true) {
              this.userRole.viewSubsidy.status = true;
              this.userRole.viewSubsidy.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 155 && subMenu.isSelected == true) {
              this.userRole.grantRelease.status = true;
              this.userRole.grantRelease.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 159 && subMenu.isSelected == true) {
              this.userRole.subsidyReportData.status = true;
              this.userRole.subsidyReportData.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 31 && mainMenu.isSelected === true) {
          this.userRole.drpManagement.status = true;
          this.userRole.drpManagement.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 117 && subMenu.isSelected == true) {
              this.userRole.addDrp.status = true;
              this.userRole.addDrp.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 118 && subMenu.isSelected == true) {
              this.userRole.approveDrp.status = true;
              this.userRole.approveDrp.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 120 && subMenu.isSelected == true) {
              this.userRole.extendUserValidity.status = true;
              this.userRole.extendUserValidity.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 32 && mainMenu.isSelected === true) {
          this.userRole.smsDashboard.status = true;
          this.userRole.smsDashboard.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 40 && mainMenu.isSelected === true) {
          this.userRole.multipleDrp.status = true;
          this.userRole.multipleDrp.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 38 && mainMenu.isSelected === true) {
          this.userRole.shiftApplication.status = true;
          this.userRole.shiftApplication.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 39 && mainMenu.isSelected === true) {
          this.userRole.zonalVerification.status = true;
          this.userRole.zonalVerification.name = mainMenu.menuName;
        }
      });


      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 28 && mainMenu.isSelected === true) {
          this.userRole.internalDashboard.status = true;
          this.userRole.internalDashboard.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 62 && mainMenu.isSelected === true) {
          this.userRole.drpDlcList.status = true;
          this.userRole.drpDlcList.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 52 && mainMenu.isSelected === true) {
          this.userRole.prayasDashboard.status = true;
          this.userRole.prayasDashboard.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 55 && mainMenu.isSelected === true) {
          this.userRole.nrlmDashboard.status = true;
          this.userRole.nrlmDashboard.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 63 && mainMenu.isSelected === true) {
          this.userRole.manageMenu.status = true;
          this.userRole.manageMenu.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 64 && mainMenu.isSelected === true) {
          this.userRole.subsidyPaymentReport.status = true;
          this.userRole.subsidyPaymentReport.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 65 && mainMenu.isSelected === true) {
          this.userRole.snaContactDetails.status = true;
          this.userRole.snaContactDetails.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 58 && mainMenu.isSelected === true) {
          this.userRole.uploadBatchFileNpmu.status = true;
          this.userRole.uploadBatchFileNpmu.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 59 && mainMenu.isSelected === true) {
          this.userRole.viewResponseFiles.status = true;
          this.userRole.viewResponseFiles.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 60 && mainMenu.isSelected === true) {
          this.userRole.subsidyProcessRequest.status = true;
          this.userRole.subsidyProcessRequest.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 61 && mainMenu.isSelected === true) {
          this.userRole.uploadResponseFiles.status = true;
          this.userRole.uploadResponseFiles.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 44 && mainMenu.isSelected === true) {
          this.userRole.mergeBranch.status = true;
          this.userRole.mergeBranch.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 43 && mainMenu.isSelected === true) {
          this.userRole.changeTransient.status = true;
          this.userRole.changeTransient.name = mainMenu.menuName;
        }
      });
      allUserRole.forEach(mainMenu => {
        if (mainMenu.menuId === 45 && mainMenu.isSelected === true) {
          this.userRole.dfs.status = true;
          this.userRole.dfs.name = mainMenu.menuName;

        }
      });
      allUserRole.forEach(mainMenu => {
        if (mainMenu.menuId === 42 && mainMenu.isSelected === true) {
          this.userRole.verifyLocation.status = true;
          this.userRole.verifyLocation.name = mainMenu.menuName;

        }
      });
      allUserRole.forEach(mainMenu => {
        if (mainMenu.menuId === 56 && mainMenu.isSelected === true) {
          this.userRole.hoReport.status = true;
          this.userRole.hoReport.name = mainMenu.menuName;

        }
      });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 37 && mainMenu.isSelected === true) {
          this.userRole.updateLocation.status = true;
          this.userRole.updateLocation.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 35 && mainMenu.isSelected === true) {
          this.userRole.hoVerification.status = true;
          this.userRole.hoVerification.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 29 && mainMenu.isSelected === true) {
          this.userRole.externalServicesAPIs.status = true;
          this.userRole.externalServicesAPIs.name = mainMenu.menuName;
        }
        mainMenu.menuLevel1.forEach((subMenu) => {
          if (subMenu.menuLevel1Id == 113 && subMenu.isSelected == true) {
            this.userRole.manageServiceTokens.status = true;
            this.userRole.manageServiceTokens.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 114 && subMenu.isSelected == true) {
            this.userRole.addServiceTokens.status = true;
            this.userRole.addServiceTokens.name = subMenu.menuLevel1Name;
          }
        });
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 30 && mainMenu.isSelected === true) {
          this.userRole.buildAndReleases.status = true;
          this.userRole.buildAndReleases.name = mainMenu.menuName;
        }
        mainMenu.menuLevel1.forEach((subMenu) => {
          if (subMenu.menuLevel1Id == 115 && subMenu.isSelected == true) {
            this.userRole.aLlReleases.status = true;
            this.userRole.aLlReleases.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 116 && subMenu.isSelected == true) {
            this.userRole.addNewBuild.status = true;
            this.userRole.addNewBuild.name = subMenu.menuLevel1Name;
          }
        });
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId === 46 && mainMenu.isSelected === true) {
          this.userRole.adminReport.status = true;
          this.userRole.adminReport.name = mainMenu.menuName;
        }
        mainMenu.menuLevel1.forEach((subMenu) => {
          if (subMenu.menuLevel1Id == 136 && subMenu.isSelected == true) {
            this.userRole.subsidyReport.status = true;
            this.userRole.subsidyReport.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 174 && subMenu.isSelected == true) {
            this.userRole.stateStb.status = true;
            this.userRole.stateStb.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 181 && subMenu.isSelected == true) {
            this.userRole.bankwiseRejected.status = true;
            this.userRole.bankwiseRejected.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 180 && subMenu.isSelected == true) {
            this.userRole.stateWiseRejected.status = true;
            this.userRole.stateWiseRejected.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 179 && subMenu.isSelected == true) {
            this.userRole.bankwisePending.status = true;
            this.userRole.bankwisePending.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 178 && subMenu.isSelected == true) {
            this.userRole.statewisePending.status = true;
            this.userRole.statewisePending.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 177 && subMenu.isSelected == true) {
            this.userRole.bankwiseSanctioned.status = true;
            this.userRole.bankwiseSanctioned.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 176 && subMenu.isSelected == true) {
            this.userRole.statewiseSanctioned.status = true;
            this.userRole.statewiseSanctioned.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 175 && subMenu.isSelected == true) {
            this.userRole.bankwiseSenttobank.status = true;
            this.userRole.bankwiseSenttobank.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 173 && subMenu.isSelected == true) {
            this.userRole.withrawnApplication.status = true;
            this.userRole.withrawnApplication.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 137 && subMenu.isSelected == true) {
            this.userRole.bankSanction.status = true;
            this.userRole.bankSanction.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 138 && subMenu.isSelected == true) {
            this.userRole.stateDfs.status = true;
            this.userRole.stateDfs.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 144 && subMenu.isSelected == true) {
            this.userRole.gatiShakti.status = true;
            this.userRole.gatiShakti.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 148 && subMenu.isSelected == true) {
            this.userRole.parkedReport.status = true;
            this.userRole.parkedReport.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 147 && subMenu.isSelected == true) {
            this.userRole.additionalDocumentReport.status = true;
            this.userRole.additionalDocumentReport.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 146 && subMenu.isSelected == true) {
            this.userRole.bankPendingReport.status = true;
            this.userRole.bankPendingReport.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 145 && subMenu.isSelected == true) {
            this.userRole.bankSanctionReport.status = true;
            this.userRole.bankSanctionReport.name = subMenu.menuLevel1Name;
          }
          if (subMenu.menuLevel1Id == 149 && subMenu.isSelected == true) {
            this.userRole.bankStatusApplicationReport.status = true;
            this.userRole.bankStatusApplicationReport.name = subMenu.menuLevel1Name;
          }
        });
      });

      // allUserRole.forEach((mainMenu) => {
      //   if (mainMenu.menuId === 47 && mainMenu.isSelected === true) {
      //     this.userRole.internalSourceReg.status = true;
      //     this.userRole.internalSourceReg.name = mainMenu.menuName;
      //   }
      // });

      // allUserRole.forEach((mainMenu) => {
      //   if (mainMenu.menuId === 48 && mainMenu.isSelected === true) {
      //     this.userRole.internalSourceListDRP.status = true;
      //     this.userRole.internalSourceListDRP.name = mainMenu.menuName;
      //   }
      // });
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 54 && mainMenu.isSelected == true) {
          this.userRole.verifiedApplication.status = true;
          this.userRole.verifiedApplication.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 167 && subMenu.isSelected == true) {
              this.userRole.allVerifiedApplication.status = true;
              this.userRole.allVerifiedApplication.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 168 && subMenu.isSelected == true) {
              this.userRole.allPendingVerifiedApplication.status = true;
              this.userRole.allPendingVerifiedApplication.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 170 && subMenu.isSelected == true) {
              this.userRole.subsidyReport.status = true;
              this.userRole.subsidyReport.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 47 && mainMenu.isSelected == true) {
          this.userRole.internalSource.status = true;
          this.userRole.internalSource.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 156 && subMenu.isSelected == true) {
              this.userRole.internalSourceReg.status = true;
              this.userRole.internalSourceReg.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 157 && subMenu.isSelected == true) {
              this.userRole.internalSourceListDRP.status = true;
              this.userRole.internalSourceListDRP.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 158 && subMenu.isSelected == true) {
              this.userRole.allinternalSourceList.status = true;
              this.userRole.allinternalSourceList.name = subMenu.menuLevel1Name;
            }
          });
        }
      });
      
      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 53 && mainMenu.isSelected == true) {
          this.userRole.zoneStateDistrict.status = true;
          this.userRole.zoneStateDistrict.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 164 && subMenu.isSelected == true) {
              this.userRole.zoneAdd.status = true;
              this.userRole.zoneAdd.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 165 && subMenu.isSelected == true) {
              this.userRole.zoneView.status = true;
              this.userRole.zoneView.name = subMenu.menuLevel1Name;
            }
           
          });
         
        }
      });

      allUserRole.forEach((mainMenu) => {

        if ((mainMenu.menuId == 3 && mainMenu.isSelected == true && this.userDetails.userType.userType != 37 && this.userDetails.bankName == null)
        ) {
          this.userRole.userManagement.status = true;
          this.userRole.userManagement.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 1 && subMenu.isSelected == true) {
              this.userRole.manageRole.status = true;
              this.userRole.manageRole.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 2 && subMenu.isSelected == true) {
              this.userRole.manageUser.status = true;
              this.userRole.manageUser.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 3 && subMenu.isSelected == true) {
              this.userRole.resetPassword.status = true;
              this.userRole.resetPassword.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 112 && subMenu.isSelected == true) {
              this.userRole.activateUser.status = true;
              this.userRole.activateUser.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 3 && mainMenu.isSelected == true && this.userDetails.userType.userType == 37 && (this.userDetails.bankName.id == 261 || this.userDetails.bankName.id == 239)
        ) {
          this.userRole.userManagement.status = true;
          this.userRole.userManagement.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {

            if (subMenu.menuLevel1Id == 134 && subMenu.isSelected == true) {
              this.userRole.axisBankUser.status = true;
              this.userRole.axisBankUser.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 150 && subMenu.isSelected == true) {
              this.userRole.searchCreatedUser.status = true;
              this.userRole.searchCreatedUser.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 19 && mainMenu.isSelected == true) {
          this.userRole.pipMainMenu.status = true;
          this.userRole.pipMainMenu.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 66 && subMenu.isSelected == true) {
              this.userRole.statePipMenu.status = true;
              this.userRole.statePipMenu.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 67 && subMenu.isSelected == true) {
              this.userRole.centralPipMenu.status = true;
              this.userRole.centralPipMenu.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 49 && mainMenu.isSelected == true) {
          this.userRole.snaReportingStaff.status = true;
          this.userRole.snaReportingStaff.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 139 && subMenu.isSelected == true) {
              this.userRole.snaReportingStaffIndivisual.status = true;
              this.userRole.snaReportingStaffIndivisual.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 140 && subMenu.isSelected == true) {
              this.userRole.snaReportingStaffNonIndivisual.status = true;
              this.userRole.snaReportingStaffNonIndivisual.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 161 && subMenu.isSelected == true) {
              this.userRole.AIFReport.status = true;
              this.userRole.AIFReport.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 20 && mainMenu.isSelected == true) {
          this.userRole.lmsMainMenu.status = true;
          this.userRole.lmsMainMenu.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 77 && subMenu.isSelected == true) {
              this.userRole.contentManagement.status = true;
              this.userRole.contentManagement.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 78 && subMenu.isSelected == true) {
              this.userRole.contentCreation.status = true;
              this.userRole.contentCreation.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 79 && subMenu.isSelected == true) {
              this.userRole.courseCreation.status = true;
              this.userRole.courseCreation.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      // ho bank starts
      this.commonService.geHoSideMenuData().then((resp: any) => {
        if (resp.status === 200) {
          if (resp["body"]["responseCode"] === 200) {
            if (resp["body"]["responseObject"].length > 0) {
              this.hoRoleData = resp["body"]["responseObject"][0];
              this.showHoMenu =
                this.hoRoleData["status"] === 1 ? true : false;
              console.log("this is show HO Menu", this.showHoMenu);
            }

          }
        }
        allUserRole.forEach((mainMenu) => {
          // console.log(mainMenu.menuId);
          // console.log(mainMenu.isSelected);

          // this.getSideBarData();
          // console.log("this is inside ho loop function", this.showHoMenu);
          if (
            mainMenu.menuId == 36 &&
            mainMenu.isSelected == true &&
            this.showHoMenu == true
          ) {
            this.userRole.bankLinkageHoMOFPI.status = true;
            this.userRole.bankLinkageHoMOFPI.name = mainMenu.menuName;
            mainMenu.menuLevel1.forEach((subMenu) => {
              if ((subMenu.menuLevel1Id == 129 && subMenu.isSelected == true && this.hoRoleData['roleid'] == 37) || (subMenu.menuLevel1Id == 129 && subMenu.isSelected == true && (this.hoRoleData['roleid'] == 43 || this.hoRoleData['roleid'] == 41))) {
                this.userRole.individualHoApproval.status = true;
                this.userRole.individualHoApproval.name =
                  subMenu.menuLevel1Name;
              }
              if ((subMenu.menuLevel1Id == 130 && subMenu.isSelected == true && this.hoRoleData['roleid'] == 37) || (subMenu.menuLevel1Id == 130 && subMenu.isSelected == true && (this.hoRoleData['roleid'] == 43 || this.hoRoleData['roleid'] == 41))) {
                this.userRole.groupHoApproval.status = true;
                this.userRole.groupHoApproval.name = subMenu.menuLevel1Name;
              }

              if ((subMenu.menuLevel1Id == 131 && subMenu.isSelected == true && this.hoRoleData['roleid'] == 37) || (subMenu.menuLevel1Id == 131 && subMenu.isSelected == true && (this.hoRoleData['roleid'] == 44 || this.hoRoleData['roleid'] == 42))) {
                this.userRole.loanDisbursementHo.status = true;
                this.userRole.loanDisbursementHo.name = subMenu.menuLevel1Name;
              }
              if ((subMenu.menuLevel1Id == 132 && subMenu.isSelected == true && this.hoRoleData['roleid'] == 37) || (subMenu.menuLevel1Id == 132 && subMenu.isSelected == true && (this.hoRoleData['roleid'] == 44 || this.hoRoleData['roleid'] == 42))) {
                this.userRole.sanctionedApplicationsHo.status = true;
                this.userRole.sanctionedApplicationsHo.name =
                  subMenu.menuLevel1Name;
              }
              if ((subMenu.menuLevel1Id == 133 && subMenu.isSelected == true && this.hoRoleData['roleid'] == 37) || (subMenu.menuLevel1Id == 133 && subMenu.isSelected == true && (this.hoRoleData['roleid'] == 44 || this.hoRoleData['roleid'] == 42))) {
                this.userRole.rollbackDisbursementHo.status = true;
                this.userRole.rollbackDisbursementHo.name =
                  subMenu.menuLevel1Name;
              }

              if ((subMenu.menuLevel1Id == 171 && subMenu.isSelected == true && this.hoRoleData['roleid'] == 37) || (subMenu.menuLevel1Id == 171 && subMenu.isSelected == true && (this.hoRoleData['roleid'] == 43 || this.hoRoleData['roleid'] == 41))) {
                this.userRole.editSanctionsDetails.status = true;
                this.userRole.editSanctionsDetails.name =
                  subMenu.menuLevel1Name;
              }
              if ((subMenu.menuLevel1Id == 172 && subMenu.isSelected == true && this.hoRoleData['roleid'] == 37) || (subMenu.menuLevel1Id == 172 && subMenu.isSelected == true && (this.hoRoleData['roleid'] == 44 || this.hoRoleData['roleid'] == 42))) {
                this.userRole.editSanctionsNotAble.status = true;
                this.userRole.editSanctionsNotAble.name =
                  subMenu.menuLevel1Name;
              }
            });
          }
        });
      });
      // ho bank ends

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 4 && mainMenu.isSelected == true) {
          this.userRole.bankLinkageMOFPI.status = true;
          this.userRole.bankLinkageMOFPI.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 9 && subMenu.isSelected == true) {
              this.userRole.bankLinkageMOFPIInner.status = true;
              this.userRole.bankLinkageMOFPIInner.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 6 && subMenu.isSelected == true) {
              this.userRole.dPRPendingApproval.status = true;
              this.userRole.dPRPendingApproval.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 7 && subMenu.isSelected == true) {
              this.userRole.editProfile.status = true;
              this.userRole.editProfile.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 11 && subMenu.isSelected == true) {
              this.userRole.loanReleaseDetails.status = true;
              this.userRole.loanReleaseDetails.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 128 && subMenu.isSelected == true) {
              this.userRole.rollbackDisbursement.status = true;
              this.userRole.rollbackDisbursement.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 12 && subMenu.isSelected == true) {
              this.userRole.nodalBankStatus.status = true;
              this.userRole.nodalBankStatus.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 10 && subMenu.isSelected == true) {
              this.userRole.nonIndividual.status = true;
              this.userRole.nonIndividual.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 122 && subMenu.isSelected == true) {
              this.userRole.sanctionedApplications.status = true;
              this.userRole.sanctionedApplications.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 8 && subMenu.isSelected == true) {
              this.userRole.subsidyStatusUpdate.status = true;
              this.userRole.subsidyStatusUpdate.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 32 && subMenu.isSelected == true) {
              this.userRole.statusUpdateMofpi.status = true;
              this.userRole.statusUpdateMofpi.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 63 && subMenu.isSelected == true) {
              this.userRole.subsidyUpdate.status = true;
              this.userRole.subsidyUpdate.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 83 && subMenu.isSelected == true) {
              this.userRole.rollBackDecision.status = true;
              this.userRole.rollBackDecision.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 162 && subMenu.isSelected == true) {
              this.userRole.pullBackDocument.status = true;
              this.userRole.pullBackDocument.name = subMenu.menuLevel1Name;
            }

            // if (subMenu.menuLevel1Id == 63 && subMenu.isSelected == true) {
            //   this.userRole.subsidyUpdate.status = true;
            //   this.userRole.subsidyUpdate.name = subMenu.menuLevel1Name
            // }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 5 && mainMenu.isSelected == true) {
          this.userRole.reports.status = true;
          this.userRole.reports.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 14 && subMenu.isSelected == true) {
              this.userRole.lendingBankReport.status = true;
              this.userRole.lendingBankReport.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 82 && subMenu.isSelected == true) {
              this.userRole.lendingBankReportV2.status = true;
              this.userRole.lendingBankReportV2.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 13 && subMenu.isSelected == true) {
              this.userRole.viewReports.status = true;
              this.userRole.viewReports.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 166 && subMenu.isSelected == true) {
              this.userRole.bankReport.status = true;
              this.userRole.bankReport.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 61 && subMenu.isSelected == true) {
              this.userRole.downloadReportBank.status = true;
              this.userRole.downloadReportBank.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 69 && subMenu.isSelected == true) {
              this.userRole.downloadReportBankGroup.status = true;
              this.userRole.downloadReportBankGroup.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 62 && subMenu.isSelected == true) {
              this.userRole.downloadReportDrpDlc.status = true;
              this.userRole.downloadReportDrpDlc.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 141 && subMenu.isSelected == true) {
              this.userRole.downloadReportIndividualStatus.status = true;
              this.userRole.downloadReportIndividualStatus.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 142 && subMenu.isSelected == true) {
              this.userRole.downloadReportGroupStatus.status = true;
              this.userRole.downloadReportGroupStatus.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 68 && subMenu.isSelected == true) {
              this.userRole.downloadReportNonInd.status = true;
              this.userRole.downloadReportNonInd.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 97 && subMenu.isSelected == true) {
              this.userRole.downloadReportIndStatusV2.status = true;
              this.userRole.downloadReportIndStatusV2.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 98 && subMenu.isSelected == true) {
              this.userRole.downloadReportNonIndStatusV2.status = true;
              this.userRole.downloadReportNonIndStatusV2.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 15 && subMenu.isSelected == true) {
              this.userRole.proposedPdtReport.status = true;
              this.userRole.proposedPdtReport.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 16 && subMenu.isSelected == true) {
              this.userRole.proposedBusinessReport.status = true;
              this.userRole.proposedBusinessReport.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 17 && subMenu.isSelected == true) {
              this.userRole.appFinInfoReport.status = true;
              this.userRole.appFinInfoReport.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 18 && subMenu.isSelected == true) {
              this.userRole.defLetterDlc.status = true;
              this.userRole.defLetterDlc.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 19 && subMenu.isSelected == true) {
              this.userRole.stateWiseApplicantProfile.status = true;
              this.userRole.stateWiseApplicantProfile.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 20 && subMenu.isSelected == true) {
              this.userRole.mostPrefBnkAprvdApp.status = true;
              this.userRole.mostPrefBnkAprvdApp.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 21 && subMenu.isSelected == true) {
              this.userRole.subAmtNtSubmitedState.status = true;
              this.userRole.subAmtNtSubmitedState.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 22 && subMenu.isSelected == true) {
              this.userRole.loanRejBothPrefBank.status = true;
              this.userRole.loanRejBothPrefBank.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 23 && subMenu.isSelected == true) {
              this.userRole.loanAmtApprvSecondBank.status = true;
              this.userRole.loanAmtApprvSecondBank.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 24 && subMenu.isSelected == true) {
              this.userRole.beneficiaryLoanTracking.status = true;
              this.userRole.beneficiaryLoanTracking.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 25 && subMenu.isSelected == true) {
              this.userRole.dprPerformanceReport.status = true;
              this.userRole.dprPerformanceReport.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 28 && subMenu.isSelected == true) {
              this.userRole.grevResolvedIssues.status = true;
              this.userRole.grevResolvedIssues.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 29 && subMenu.isSelected == true) {
              this.userRole.grevNtResolvedNoAction.status = true;
              this.userRole.grevNtResolvedNoAction.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 49 && subMenu.isSelected == true) {
              this.userRole.defficiencyLetterState.status = true;
              this.userRole.defficiencyLetterState.name =
                subMenu.menuLevel1Name;
            }

            // if (subMenu.menuLevel1Id == 48 && subMenu.isSelected == true) {
            //   this.userRole.defficiencyLetterState.status = true;
            //   this.userRole.defficiencyLetterState.name = subMenu.menuLevel1Name
            // }

            if (subMenu.menuLevel1Id == 44 && subMenu.isSelected == true) {
              this.userRole.loginUserReport.status = true;
              this.userRole.loginUserReport.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 119 && subMenu.isSelected == true) {
              this.userRole.formalisationReport.status = true;
              this.userRole.formalisationReport.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 123 && subMenu.isSelected == true) {
              this.userRole.sanctionButNotDisbursed.status = true;
              this.userRole.sanctionButNotDisbursed.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 143 && subMenu.isSelected == true) {
              this.userRole.downloadLendingBank.status = true;
              this.userRole.downloadLendingBank.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 160 && subMenu.isSelected == true) {
              this.userRole.downloadMonthlyApplicantDetail.status = true;
              this.userRole.downloadMonthlyApplicantDetail.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 163 && subMenu.isSelected == true) {
              this.userRole.downloadIndAndGroup.status = true;
              this.userRole.downloadIndAndGroup.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 34 && mainMenu.isSelected == true) {
          this.userRole.hoBankUserMgmt.status = true;
          this.userRole.hoBankUserMgmt.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 124 && subMenu.isSelected == true) {
              this.userRole.hoAddBank.status = true;
              this.userRole.hoAddBank.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 125 && subMenu.isSelected == true) {
              this.userRole.hoEditBank.status = true;
              this.userRole.hoEditBank.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 126 && subMenu.isSelected == true) {
              this.userRole.hoResetPassword.status = true;
              this.userRole.hoResetPassword.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 127 && subMenu.isSelected == true) {
              this.userRole.hoActivateId.status = true;
              this.userRole.hoActivateId.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 6 && mainMenu.isSelected == true) {
          this.userRole.grievance.status = true;
          this.userRole.grievance.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 51 && mainMenu.isSelected == true) {
          this.userRole.formalisation.status = true;
          this.userRole.formalisation.name = mainMenu.menuName;
        }
      });


      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 16 && mainMenu.isSelected == true) {
          this.userRole.guidelinesInstructions.status = true;
          this.userRole.guidelinesInstructions.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 17 && mainMenu.isSelected == true) {
          this.userRole.userManual.status = true;
          this.userRole.userManual.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 18 && mainMenu.isSelected == true) {
          this.userRole.applicationView.status = true;
          this.userRole.applicationView.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 7 && mainMenu.isSelected == true) {
          this.userRole.monitoringMainMenu.status = true;
          this.userRole.monitoringMainMenu.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 30 && subMenu.isSelected == true) {
              this.userRole.fundMonitoring.status = true;
              this.userRole.fundMonitoring.name = subMenu.menuLevel1Name;
            }

            // if (subMenu.menuLevel1Id == 34 && subMenu.isSelected == true) {
            //   this.userRole.totalSalesReport.status = true;
            //   this.userRole.totalSalesReport.name = subMenu.menuLevel1Name
            // }

            if (subMenu.menuLevel1Id == 35 && subMenu.isSelected == true) {
              this.userRole.totalCertificatesReport.status = true;
              this.userRole.totalCertificatesReport.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 36 && subMenu.isSelected == true) {
              this.userRole.totalInvestmentReport.status = true;
              this.userRole.totalInvestmentReport.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 38 && subMenu.isSelected == true) {
              this.userRole.totalWorkersReport.status = true;
              this.userRole.totalWorkersReport.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 8 && mainMenu.isSelected == true) {
          this.userRole.schemeFundAccounting.status = true;
          this.userRole.schemeFundAccounting.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 9 && mainMenu.isSelected == true) {
          this.userRole.convergenceModule.status = true;
          this.userRole.convergenceModule.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 11 && mainMenu.isSelected == true) {
          this.userRole.grievanceRedressal.status = true;
          this.userRole.grievanceRedressal.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 12 && mainMenu.isSelected == true) {
          this.userRole.monitoringReport.status = true;
          this.userRole.monitoringReport.name = mainMenu.menuName;

          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 40 && subMenu.isSelected == true) {
              this.userRole.projectMonitoring.status = true;
              this.userRole.projectMonitoring.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 41 && subMenu.isSelected == true) {
              this.userRole.bankApprovedAppRep.status = true;
              this.userRole.bankApprovedAppRep.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 42 && subMenu.isSelected == true) {
              this.userRole.bankApprovedAppGraphRep.status = true;
              this.userRole.bankApprovedAppGraphRep.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 43 && subMenu.isSelected == true) {
              this.userRole.totalSubsidyDisRep.status = true;
              this.userRole.totalSubsidyDisRep.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 46 && subMenu.isSelected == true) {
              this.userRole.beneficiaryStatusReport.status = true;
              this.userRole.beneficiaryStatusReport.name =
                subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 47 && subMenu.isSelected == true) {
              this.userRole.grievanceCountReport.status = true;
              this.userRole.grievanceCountReport.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 50 && subMenu.isSelected == true) {
              this.userRole.loanOutstandingStatus.status = true;
              this.userRole.loanOutstandingStatus.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 51 && subMenu.isSelected == true) {
              this.userRole.loanDefaulters.status = true;
              this.userRole.loanDefaulters.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 52 && subMenu.isSelected == true) {
              this.userRole.loanSanctionRejection.status = true;
              this.userRole.loanSanctionRejection.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 53 && subMenu.isSelected == true) {
              this.userRole.certificationsStandardAchieved.status = true;
              this.userRole.certificationsStandardAchieved.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 54 && subMenu.isSelected == true) {
              this.userRole.beneficiaryBusinessLifecycle.status = true;
              this.userRole.beneficiaryBusinessLifecycle.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 55 && subMenu.isSelected == true) {
              this.userRole.beneficiaryBusinessLifecycleApplicantType.status =
                true;
              this.userRole.beneficiaryBusinessLifecycleApplicantType.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 56 && subMenu.isSelected == true) {
              this.userRole.totalWorkerEmployedBeneficiary.status = true;
              this.userRole.totalWorkerEmployedBeneficiary.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 57 && subMenu.isSelected == true) {
              this.userRole.loanSanctionRejectionOverallBeneficiary.status =
                true;
              this.userRole.loanSanctionRejectionOverallBeneficiary.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 58 && subMenu.isSelected == true) {
              this.userRole.loanSanctionRejectionOverallBanklevel.status = true;
              this.userRole.loanSanctionRejectionOverallBanklevel.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 60 && subMenu.isSelected == true) {
              this.userRole.beneficiarySalesReport.status = true;
              this.userRole.beneficiarySalesReport.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 34 && subMenu.isSelected == true) {
              this.userRole.totalSalesReport.status = true;
              this.userRole.totalSalesReport.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 37 && subMenu.isSelected == true) {
              this.userRole.loanDefaultersReport.status = true;
              this.userRole.loanDefaultersReport.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 45 && subMenu.isSelected == true) {
              this.userRole.beneficiarLifeCycle.status = true;
              this.userRole.beneficiarLifeCycle.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 33 && subMenu.isSelected == true) {
              this.userRole.loanEmiRepaymentReport.status = true;
              this.userRole.loanEmiRepaymentReport.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 39 && subMenu.isSelected == true) {
              this.userRole.applicantsNumberLoanRepaymentReport.status = true;
              this.userRole.applicantsNumberLoanRepaymentReport.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 31 && subMenu.isSelected == true) {
              this.userRole.performanceMonitoring.status = true;
              this.userRole.performanceMonitoring.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 13 && mainMenu.isSelected == true) {
          this.userRole.dashboardsDataAnalytics.status = true;
          this.userRole.dashboardsDataAnalytics.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 22 && mainMenu.isSelected == true) {
          this.userRole.draftApplications.status = true;
          this.userRole.draftApplications.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 33 && mainMenu.isSelected == true) {
          this.userRole.searchIfsc.status = true;
          this.userRole.searchIfsc.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 14 && mainMenu.isSelected == true) {
          this.userRole.schemeSitesSubSites.status = true;
          this.userRole.schemeSitesSubSites.name = mainMenu.menuName;

          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 64 && subMenu.isSelected == true) {
              this.userRole.viewSiteSubsite.status = true;
              this.userRole.viewSiteSubsite.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 65 && subMenu.isSelected == true) {
              this.userRole.editSiteSubsite.status = true;
              this.userRole.editSiteSubsite.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 70 && subMenu.isSelected == true) {
              this.userRole.manageImageGallery.status = true;
              this.userRole.manageImageGallery.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 71 && subMenu.isSelected == true) {
              this.userRole.manageLatestUpdate.status = true;
              this.userRole.manageLatestUpdate.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 72 && subMenu.isSelected == true) {
              this.userRole.manageSlupStudies.status = true;
              this.userRole.manageSlupStudies.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 73 && subMenu.isSelected == true) {
              this.userRole.manageContactDetails.status = true;
              this.userRole.manageContactDetails.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 99 && subMenu.isSelected == true) {
              this.userRole.manageWhatsNew.status = true;
              this.userRole.manageWhatsNew.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 100 && subMenu.isSelected == true) {
              this.userRole.manageImportantLinks.status = true;
              this.userRole.manageImportantLinks.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 101 && subMenu.isSelected == true) {
              this.userRole.manageMediaLinks.status = true;
              this.userRole.manageMediaLinks.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 74 && subMenu.isSelected == true) {
              this.userRole.manageOdop.status = true;
              this.userRole.manageOdop.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 95 && subMenu.isSelected == true) {
              this.userRole.uploadSampleProduct.status = true;
              this.userRole.uploadSampleProduct.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 96 && subMenu.isSelected == true) {
              this.userRole.successStories.status = true;
              this.userRole.successStories.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 75 && subMenu.isSelected == true) {
              this.userRole.manageWebsiteLinks.status = true;
              this.userRole.manageWebsiteLinks.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 76 && subMenu.isSelected == true) {
              this.userRole.manageBannerImages.status = true;
              this.userRole.manageBannerImages.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 15 && mainMenu.isSelected == true) {
          this.userRole.mobileInterfaces.status = true;
          this.userRole.mobileInterfaces.name = mainMenu.menuName;
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 23 && mainMenu.isSelected == true) {
          this.userRole.trainingMainMenu.status = true;
          this.userRole.trainingMainMenu.name = mainMenu.menuName;
          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 84 && subMenu.isSelected == true) {
              this.userRole.trainingCreation.status = true;
              this.userRole.trainingCreation.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 85 && subMenu.isSelected == true) {
              this.userRole.directEnrollment.status = true;
              this.userRole.directEnrollment.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 86 && subMenu.isSelected == true) {
              this.userRole.resultUpdate.status = true;
              this.userRole.resultUpdate.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 87 && subMenu.isSelected == true) {
              this.userRole.updateTraining.status = true;
              this.userRole.updateTraining.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 88 && subMenu.isSelected == true) {
              this.userRole.trainingCommencement.status = true;
              this.userRole.trainingCommencement.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 89 && subMenu.isSelected == true) {
              this.userRole.viewTraining.status = true;
              this.userRole.viewTraining.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 90 && subMenu.isSelected == true) {
              this.userRole.snaSltiTraining.status = true;
              this.userRole.snaSltiTraining.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 91 && subMenu.isSelected == true) {
              this.userRole.regMasterTrainer.status = true;
              this.userRole.regMasterTrainer.name = subMenu.menuLevel1Name;
            }

            if (subMenu.menuLevel1Id == 92 && subMenu.isSelected == true) {
              this.userRole.trainerApproval.status = true;
              this.userRole.trainerApproval.name = subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 21 && mainMenu.isSelected == true) {
          this.userRole.incubationCentre.status = true;
          this.userRole.incubationCentre.name = mainMenu.menuName;

          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 80 && subMenu.isSelected == true) {
              this.userRole.incubationCentreReport.status = true;
              this.userRole.incubationCentreReport.name =
                subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 81 && subMenu.isSelected == true) {
              this.userRole.incubationCentreReportDetails.status = true;
              this.userRole.incubationCentreReportDetails.name =
                subMenu.menuLevel1Name;
            }
          });
        }
      });

      allUserRole.forEach((mainMenu) => {
        if (mainMenu.menuId == 24 && mainMenu.isSelected == true) {
          this.userRole.cmsReport.status = true;
          this.userRole.cmsReport.name = mainMenu.menuName;

          mainMenu.menuLevel1.forEach((subMenu) => {
            if (subMenu.menuLevel1Id == 93 && subMenu.isSelected == true) {
              this.userRole.detailedContentReport.status = true;
              this.userRole.detailedContentReport.name = subMenu.menuLevel1Name;
            }
            if (subMenu.menuLevel1Id == 94 && subMenu.isSelected == true) {
              this.userRole.contentExpenditure.status = true;
              this.userRole.contentExpenditure.name = subMenu.menuLevel1Name;
            }
          });
        }
      });
    }
  }

  async downloadLandingBankReport() {
    let resp;
    try {
      this.sharedService.showLoader();
        await this.commonService.downloadLandingBankReport().then(
        (data: ArrayBuffer) => {
          this.saveFileLendingBank(data);
          console.log("File downloaded successfully.");
        },
        (error) => {
          console.error("Error downloading the file.", error);
        }
      );
      // this.sharedService.showLoader();
      // resp = await this.commonService.downloadLandingBankReport();
     
      // if (resp) {
     
      //   var file = new Blob([resp], {
      //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      //   });
      //   var fileURL = URL.createObjectURL(file);
      //   window.open(fileURL);
      // } else {
      //   this.sharedService.showError(COMMONTEXT.CANT_PREVIEW);
      // }
    } catch (error) {
      //  console.log('EORROR ', error)
      // this.sharedService.hideLoader();
    }
  }

  saveFileLendingBank(data: ArrayBuffer) {
    var filename = "PMFME_Individual_Application_report(Bank Level).xlsx";
    console.log(filename)
    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // Excel MIME type
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename; // Custom file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

  async downloadLandingBankReportGroup() {
    let resp;
    try {
       this.sharedService.showLoader();
        await this.commonService.downloadLandingBankReportGroup().then(
        (data: ArrayBuffer) => {
          this.saveFileLendingBankGroup(data);
          console.log("File downloaded successfully.");
        },
        (error) => {
          console.error("Error downloading the file.", error);
        }
      );

      // this.sharedService.showLoader();
      // resp = await this.commonService.downloadLandingBankReportGroup();
     
      // if (resp) {
       
      //   var file = new Blob([resp], {
      //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      //   });
      //   var fileURL = URL.createObjectURL(file);
      //   window.open(fileURL);
      // } else {
      //   this.sharedService.showError(COMMONTEXT.CANT_PREVIEW);
      // }
    } catch (error) {
     
    }
  }

  saveFileLendingBankGroup(data: ArrayBuffer) {
    var filename = "PMFME_Individual_Application_report(Bank Level).xlsx";
    console.log(filename)
    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // Excel MIME type
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename; // Custom file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

  async downloadReport() {
    let resp;
    try {
      this.sharedService.showLoader();
      resp = await this.commonService.downloadReport().then(
        // if (resp) {
            (data: ArrayBuffer) => {
                                this.saveFile(data);
                                console.log("File downloaded successfully.");
                            },
                            (error) => {
                                console.error("Error downloading the file.", error);
                            }
                        );
    } catch (error) { }
    //   // this.sharedService.hideLoader();
    //   if (resp) {
        
    //     var file = new Blob([resp], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });
    //     var fileURL = URL.createObjectURL(file);
    //     window.open(fileURL);
    //   } else {
    //     this.sharedService.showError(COMMONTEXT.CANT_PREVIEW);
    //   }
    // } catch (error) {
    
    //  }
  }

  async downloadReportNonInd() {
    let resp;
    try {
      this.sharedService.showLoader();
      resp = await this.commonService.downloadReportNonInd().then(
        // if (resp) {
            (data: ArrayBuffer) => {
                                this.saveFileGroup(data);
                                console.log("File downloaded successfully.");
                            },
                            (error) => {
                                console.error("Error downloading the file.", error);
                            }
                        );
    } catch (error) { }
      // this.sharedService.hideLoader();
    //   if (resp) {
    //     // var file = new Blob([resp], { type: 'application/vnd.ms-excel' });
    //     var file = new Blob([resp], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });
    //     var fileURL = URL.createObjectURL(file);
    //     window.open(fileURL);
    //   } else {
    //     this.sharedService.showError(COMMONTEXT.CANT_PREVIEW);
    //   }
    // } catch (error) {
    //   // console.log('EORROR ', error)
    //   // this.sharedService.hideLoader();
    // }
  }
  saveFile(data: ArrayBuffer) {
    var filename = "PMFME_Individual_Application_Status_report.xlsx";
    console.log(filename)
    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // Excel MIME type
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename; // Custom file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}
saveFileGroup(data: ArrayBuffer) {
  var filename = "PMFME_Group_Application_Status_report.xlsx";
  console.log(filename)
  const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // Excel MIME type
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename; // Custom file name
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
  // async downloadReport() {
  //   let resp;
  //   try {
  //     this.sharedService.showLoader();
  //     resp = await this.commonService.downloadReport();
  //     // this.sharedService.hideLoader();
  //     if (resp) {
  //       // var file = new Blob([resp], { type: 'application/vnd.ms-excel' });
  //       var file = new Blob([resp], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       var fileURL = URL.createObjectURL(file);
  //       window.open(fileURL);
  //     } else {
  //       this.sharedService.showError(COMMONTEXT.CANT_PREVIEW);
  //     }
  //   } catch (error) {
  //     // console.log('EORROR ', error)
  //     // this.sharedService.hideLoader();
  //   }
  // }

  // async downloadReportNonInd() {
  //   let resp;
  //   try {
  //     this.sharedService.showLoader();
  //     resp = await this.commonService.downloadReportNonInd();
  //     // this.sharedService.hideLoader();
  //     if (resp) {
  //       // var file = new Blob([resp], { type: 'application/vnd.ms-excel' });
  //       var file = new Blob([resp], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       var fileURL = URL.createObjectURL(file);
  //       window.open(fileURL);
  //     } else {
  //       this.sharedService.showError(COMMONTEXT.CANT_PREVIEW);
  //     }
  //   } catch (error) {
  //     // console.log('EORROR ', error)
  //     // this.sharedService.hideLoader();
  //   }
  // }

  downloadReportIndStatusV2A(event) {
    const reqObjDetails = {
      state: null,
      district: null,
      category: null,
      conversionId: null,
    };
    // if (
    //   this.userDetails.userType.userType == 32 ||
    //   this.userDetails.userType.userType == 33 ||
    //   this.userDetails.userType.userType == 49 ||
    //   this.userDetails.userType.userType == 50 ||
    //   this.userDetails.userType.userType == 51 ||
    //   this.userDetails.userType.userType == 52 ||
    //   this.userDetails.userType.userType == 53 ||
    //   this.userDetails.userType.userType == 54 ||
    //   this.userDetails.userType.userType == 55 ||
    //   this.userDetails.userType.userType == 57 ||
    //   this.userDetails.userType.userType == 58 ||
    //   this.userDetails.userType.userType == 48
    // ) {
    //   reqObjDetails.conversionId = 1
    // }

    if (this.userDetails.userType.userType == 32) {
      reqObjDetails.conversionId = 1
    }

    if (this.userDetails.userType.userType == 33) {
      reqObjDetails.conversionId = 2
    }

    if (this.userDetails.userType.userType == 48) {
      reqObjDetails.conversionId = 3
    }

    if (this.userDetails.userType.userType == 49) {
      reqObjDetails.conversionId = 4
    }

    if (this.userDetails.userType.userType == 50) {
      reqObjDetails.conversionId = 5
    }

    if (this.userDetails.userType.userType == 51) {
      reqObjDetails.conversionId = 6
    }

    if (this.userDetails.userType.userType == 52) {
      reqObjDetails.conversionId = 7
    }

    if (this.userDetails.userType.userType == 53) {
      reqObjDetails.conversionId = 8
    }

    if (this.userDetails.userType.userType == 54) {
      reqObjDetails.conversionId = 9
    }

    if (this.userDetails.userType.userType == 55) {
      reqObjDetails.conversionId = 10
    }

    if (this.userDetails.userType.userType == 56) {
      reqObjDetails.conversionId = 11
    }

    if (this.userDetails.userType.userType == 57) {
      reqObjDetails.conversionId = 1;
      reqObjDetails["state"] = this.userDetails.state.stateCode;
    }

    if (this.userDetails.userType.userType == 58) {
      reqObjDetails.conversionId = 2;
      reqObjDetails["state"] = this.userDetails.state.stateCode;
    }

    if (this.userDetails.userType.userType == 59) {
      reqObjDetails.conversionId = 1
    }






    if (
      this.userDetails.userType.userType == 3 ||
      this.userDetails.userType.userType == 4
    ) {
      reqObjDetails["state"] = this.userDetails.state.stateCode;
      reqObjDetails["district"] = null;
    }

    if (
      this.userDetails.userType.userType == 1 ||
      this.userDetails.userType.userType == 2
    ) {
      reqObjDetails["state"] = this.userDetails.state.stateCode;
      reqObjDetails["district"] = this.userDetails.district.districtCode;
    }
    if (this.userDetails.userType.userType == 5) {
      reqObjDetails["state"] = null;
      reqObjDetails["district"] = null;
    }
    if (event == "IND") {
      reqObjDetails["category"] = 1;

    }
    if (event == "NON") {
      reqObjDetails["category"] = 2;
    }

    this.downloadReportIndStatusV2(reqObjDetails,event);
  }

  async downloadReportIndStatusV2(reqObjDetails,event) {
    let resp;

    try {

      this.sharedService.showLoader();
      await this.commonService.applicationStatusReportV2(reqObjDetails).then(
        (data: ArrayBuffer) => {
          if (event == "IND") {
            this.saveFileIndStatusV2(data);
          }

          if (event == "NON") {
            this.saveFileGroupStatusV2(data);
          }
        console.log("File downloaded successfully.");
        },
        (error) => {
          console.error("Error downloading the file.", error);
        }
      );
      // resp = await this.commonService.applicationStatusReportV2(reqObjDetails);
      // if (resp) {
      
      //   var file = new Blob([resp], {
      //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      //   });
      //   var fileURL = URL.createObjectURL(file);
      //   window.open(fileURL);
      // } else {
      //   this.sharedService.showError(COMMONTEXT.CANT_PREVIEW);
      // }
    } catch (error) { }
  }

  saveFileIndStatusV2(data: ArrayBuffer) {
    var filename = "PMFME_Indvidual_Application_Status_report_V2.xlsx";
    console.log(filename)

    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // Excel MIME type
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename; // Custom file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  saveFileGroupStatusV2(data: ArrayBuffer) {
    var filename = "PMFME_Group_Application_Status_report_V2.xlsx";
    console.log(filename)

    const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // Excel MIME type
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename; // Custom file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
